import { GetCustomerPoliciesResponse } from '@aaa-ncnu-ie/mypolicy-api-customers'; // A policy is NextGen (PLPC) when its `dataSource` is 'plpc', matched
// case-insensitively and ignoring surrounding whitespace.
export const NEXTGEN_DATA_SOURCE = 'plpc';

export const NEXTGEN_BUNDLED_DISCOUNTS = {
  auto: '7',
  property: '10',
} as const;

export const isNextGenPolicy = (dataSource?: string): boolean =>
  (dataSource ?? '').trim().toLowerCase() === NEXTGEN_DATA_SOURCE;

export const hasNextGenPolicy = (
  policies?: { dataSource: string }[]
): boolean => !!policies?.some((policy) => isNextGenPolicy(policy.dataSource));

// NEXTGEN-FLAG: on flag retirement, delete the `nextGenEnabled` param here and at
// the call sites (the hardcoded values become unconditional for NG accounts).
export const getBundledDiscounts = (
  data?: GetCustomerPoliciesResponse,
  nextGenEnabled: boolean = false
): { autoDiscount: string; propertyDiscount: string } => {
  if (nextGenEnabled && hasNextGenPolicy(data?.policies)) {
    return {
      autoDiscount: NEXTGEN_BUNDLED_DISCOUNTS.auto,
      propertyDiscount: NEXTGEN_BUNDLED_DISCOUNTS.property,
    };
  }

  const { auto = '', home = '' } = data?.crossSellInfo?.bundledDiscounts ?? {};
  return { autoDiscount: auto, propertyDiscount: home };
};
